<div class="container-table">
  <mat-table
    [class.isMobile]="true"
    #table
    class="table table-p1 borderless align-middle"
    matSortDisableClear
    [dataSource]="dataSource"
    matSort
    matSortDirection="desc"
  >
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Nº da Ordem</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <ng-template #bottomSheetContent>
          <app-order-payment [order]="row"></app-order-payment>
        </ng-template>

        <span class="mobile-label">Nº da Ordem:</span>

        <p
          class="tappable label-desktop order-id"
          (click)="openOrderDetailsModal(row)"
        >
          {{ row?.id }}
        </p>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Data de criação</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Data de criação:</span>

        <span class="label-desktop label-data">
          {{ row?.createdDate | date : "dd/MM/yyyy" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="outReceiverName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Nome do beneficiário</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Nome do beneficiário:</span>

        <span class="label-desktop label-data">
          {{ row?.receiver?.name }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="amount">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p *ngIf="rType == '0'" class="label-desktop">Valor recebido</p>
        <p *ngIf="rType == '1'" class="label-desktop">Valor de destino</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span *ngIf="rType == '0'" class="mobile-label">Valor recebido:</span>
        <span *ngIf="rType == '1'" class="mobile-label">Valor de destino:</span>

        <div *ngIf="row?.currency?.description" class="label-desktop">
          {{ row?.amount | currency : row?.currency?.description }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Status</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Status:</span>

        <p class="size-row label-data" *ngIf="row?.statusFlow == 'PROCESSING'">
          Em análise
        </p>
        <p
          class="size-row label-data"
          *ngIf="row?.statusFlow == 'REPROVED_WITH_CORRECTION'"
        >
          Reprovada
        </p>
        <p
          class="size-row label-data"
          *ngIf="row?.statusFlow == 'AVAILABLE_QUOTATION'"
        >
          Aguardando cotação
        </p>
        <p
          class="size-row"
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'PAYMENT_REPROVED') &&
            row.remmitanceType == 'OUTBOUND'
          "
        >
          Aguardando efetivação
        </p>
        <p class="size-row label-data" *ngIf="row?.statusFlow == 'CANCELED'">
          Cancelada
        </p>

        <p
          class="size-row label-data"
          *ngIf="row?.statusFlow == 'IDENTIFYING_PAYMENT' && row?.remmitanceType == 'OUTBOUND'"
        >
          Aguardando efetivação
        </p>

        <p
          class="size-row label-data"
          *ngIf="row?.statusFlow == 'IDENTIFYING_PAYMENT' && row?.remmitanceType == 'INBOUND'"
        >
          Identificando pagamento
        </p>

        <p
          class="size-row label-data"
          *ngIf="row?.statusFlow == 'IDENTIFIED_PAYMENT'"
        >
          Pagamento identificado
        </p>

        <p
          class="size-row label-data"
          *ngIf="row?.statusFlow == 'IDENTIFYING_PAYMENT_ABROAD'"
        >
          Aguardando pagamento no exterior
        </p>

        <p
          class="size-row label-data"
          *ngIf="row?.statusFlow == 'PENDING_INVOICE_ATTACHMENT'"
        >
          Ordem criada
        </p>

        <span
          class="size-row label-data"
          *ngIf="
            row?.statusFlow == 'IDENTIFIED_PAYMENT_ABROAD' ||
            row?.statusFlow == 'PENDING_PAYMENT_INFORMATION' ||
            row?.statusFlow == 'PENDING_ORDER_INFORMATION'
          "
          ><img
            class="pr-2"
            src="assets/image/information-icon-red.svg"
          />Pendente informações</span
        >

        <p
          class="size-row label-data"
          *ngIf="
            row?.statusFlow == 'AVAILABLE_PAYMENT' &&
            row?.remmitanceType == 'INBOUND'
          "
        >
          Fechamento concluído
        </p>

        <p class="size-row label-data" *ngIf="row?.statusFlow == 'PAID'">
          Liquidada
        </p>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        <p class="label-desktop">Ações</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Ações:</span>

        <p
          class="size-row label-data text-center"
          *ngIf="
            row?.statusFlow == 'PROCESSING' ||
            row?.statusFlow == 'CANCELED' ||
            row?.statusFlow == 'IDENTIFYING_PAYMENT' ||
            row?.statusFlow == 'IDENTIFIED_PAYMENT' ||
            row?.statusFlow == 'PENDING_INVOICE_ATTACHMENT'
          "
        >
          -
        </p>
        <p
          class="size-row label-data text-center"
          *ngIf="
            row?.statusFlow == 'AVAILABLE_PAYMENT' &&
            row?.remmitanceType == 'INBOUND'
          "
        >
          -
        </p>
        <p
          class="tappable label-action size-row"
          (click)="openQuotationModal(row)"
          *ngIf="row?.statusFlow == 'AVAILABLE_QUOTATION'"
        >
          Cotar
        </p>
        <p
          [matMenuTriggerFor]="beforeMenu"
          class="tappable label-action size-row download-btn"
          *ngIf="
            row?.statusFlow == 'PAID' &&
            (row?.orderSettlement?.exchangeContractFile ||
              row?.orderSettlement?.proofOperationFile)
          "
        >
          Baixar
        </p>

        <mat-menu class="my-menu" #beforeMenu="matMenu" xPosition="before">
          <div class="download-document">
            <span>Baixar documentos</span>
          </div>
          <button
            *ngIf="
              row?.statusFlow == 'PAID' &&
              row?.orderSettlement?.exchangeContractFile
            "
            mat-menu-item
            class="custom-button"
            (click)="
              downloadAttachment(row?.orderSettlement?.exchangeContractFile)
            "
          >
            <div class="icon-and-image">
              <img src="assets/image/clip-icon.svg" />

              <span> Contrato de câmbio </span>
            </div>

            <img src="assets/image/download-icon.svg" />
          </button>
          <button
            *ngIf="
              row?.statusFlow == 'PAID' &&
              row?.orderSettlement?.proofOperationFile
            "
            mat-menu-item
            class="custom-button"
            (click)="
              downloadAttachment(row?.orderSettlement?.proofOperationFile)
            "
          >
            <div class="icon-and-image">
              <img src="assets/image/clip-icon.svg" />

              <span> Comprovantes </span>
            </div>

            <img src="assets/image/download-icon.svg" />
          </button>
        </mat-menu>

        <p
          class="tappable label-action size-row"
          *ngIf="row?.statusFlow == 'IDENTIFYING_PAYMENT_ABROAD'"
          (click)="openBankChannelModal(row?.currency?.description)"
        >
          Consultar
        </p>

        <p
          class="tappable label-action size-row"
          *ngIf="row?.statusFlow == 'IDENTIFIED_PAYMENT_ABROAD'"
          (click)="openUpdateOrderModal(row)"
        >
          Informar
        </p>

        <p
          class="tappable label-action size-row"
          *ngIf="row?.statusFlow == 'PENDING_PAYMENT_INFORMATION'"
          (click)="openPaymentInboundModal(row)"
        >
          Informar
        </p>

        <p
          class="tappable label-action size-row"
          (click)="openOrderPaymentModal(row)"
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'PAYMENT_REPROVED') &&
            row?.remmitanceType == 'OUTBOUND'
          "
        >
          Pagar
        </p>

        <p
          class="tappable label-action size-row"
          *ngIf="row?.statusFlow == 'REPROVED_WITH_CORRECTION'"
          (click)="openSendDocumentsReviewModal(row)"
        >
          Corrigir
        </p>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Nome do pagador</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Nome do pagador:</span>

        <span class="size-row">
          {{ row?.sender?.companyName }}
        </span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: displayedColumns">
    </mat-row>
  </mat-table>
</div>

<mat-paginator
  [pageSize]="pageSize"
  [pageIndex]="pageNumber"
  [length]="totalElements"
  [pageSizeOptions]="[5, 10, 25, 50]"
  showFirstLastButtons
  (page)="onPageChange($event)"
></mat-paginator>
